import { Box, Typography, Checkbox, FormControlLabel, CircularProgress } from "@mui/material";

const VerifyCheckbox = ({ commissioningState, isMutating, mutation, isDisabled }) => {
  const label = "I have tested the device and verified the validity of the data.";
  const checkboxIsChecked = commissioningState.selectedDevice.is_completed;
  const elementID = commissioningState.selectedDevice.step_id;
  const modifiedBy = commissioningState.selectedDevice.modified_by;

  return (
    <div>
      <FormControlLabel
        sx={{ display: "flex", alignItems: "center" }}
        control={
          isMutating ? (
            <Box sx={{ px: 3 }}>
              <CircularProgress size={24} />
            </Box>
          ) : (
            <Checkbox
              sx={{ pl: 5 }}
              checked={checkboxIsChecked}
              onChange={(e) =>
                mutation({
                  item_id: elementID,
                  item_value: e.target.checked,
                  warnings: commissioningState.stepValidationWarnings,
                })
              }
              disabled={isDisabled}
            />
          )
        }
        label={
          <Typography variant="body1" fontWeight="medium">
            {label}
          </Typography>
        }
      />
      {checkboxIsChecked && (
        <Box mt={1} pl={4}>
          {
            <Typography variant="body2" fontWeight="bold">
              {"Confirmed by user: " + modifiedBy}
            </Typography>
          }
        </Box>
      )}
    </div>
  );
};

export default VerifyCheckbox;
